import * as React from "react"

import { cn } from "@/lib/utils"

export interface TextareaProps
  extends React.TextareaHTMLAttributes<HTMLTextAreaElement> {
  label?: string
  hint?: string
  rows?: number
}

const Textarea = React.forwardRef<HTMLTextAreaElement, TextareaProps>(
  ({ className, label, hint, rows=4, ...props }, ref) => {
    return (
      <div className="flex flex-col gap-1">
        {label && <label className="text-neutral-600">{label}</label>}
        <div className="flex min-h-[60px] text-main-black w-full items-center py-3 gap-4 rounded-md bg-neutral-200 px-4">
          <textarea
            rows={rows}
            className={cn(
              "flex h-full appearance-none w-full bg-transparent focus:outline-none ring-0 outline-none focus:ring-0 placeholder:text-muted-foreground focus-visible:outline-none disabled:cursor-not-allowed disabled:opacity-50",
              className
            )}
            ref={ref}
            {...props}
          />
        </div>
        <p
          className={cn("h-3 text-neutral-600", {
            "opacity-0": !hint,
          })}
        >
          {hint}
        </p>
      </div>
    )
  }
)
Textarea.displayName = "Textarea"

export { Textarea }
